import * as React from "react";
import type { SizeDetailState } from "../useSizeDetail";

export function useItemDetailPricing(infoDetail: SizeDetailState) {
  return React.useMemo(() => {
    let priceItem: unknown;
    if (infoDetail?.user_group_prices?.[0]) {
      priceItem = infoDetail.user_group_prices[0]?.price;
    }

    const regularPriceNumber = Number(priceItem) || 0;
    const groupPriceAny = (infoDetail?.user_group_prices?.[0] as any) || undefined;
    const salePriceRaw =
      groupPriceAny?.price_sale ??
      groupPriceAny?.sale_price ??
      groupPriceAny?.priceSale ??
      (infoDetail as any)?.price_sale ??
      (infoDetail as any)?.sale_price ??
      (infoDetail as any)?.priceSale;
    const salePriceNumber = Number(salePriceRaw) || 0;
    const hasPrice = regularPriceNumber > 0;
    const hasSale = salePriceNumber > 0 && salePriceNumber < regularPriceNumber;

    return {
      priceItem,
      regularPriceNumber,
      salePriceNumber,
      hasPrice,
      hasSale,
    };
  }, [infoDetail]);
}
